var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10C14.6667 12.58 12.58 14.6667 10 14.6667L10.7 13.5",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 6.00065C1.33594 3.42065 3.4226 1.33398 6.0026 1.33398L5.3026 2.50065",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13281 2.9668L11.7861 4.50012L14.4128 2.97347",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7891 7.21415V4.49414",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1584 1.47398L9.55843 2.36062C9.19843 2.56062 8.89844 3.06728 8.89844 3.48062V5.17398C8.89844 5.58731 9.19176 6.09397 9.55843 6.29397L11.1584 7.18065C11.4984 7.37398 12.0584 7.37398 12.4051 7.18065L14.0051 6.29397C14.3651 6.09397 14.6651 5.58731 14.6651 5.17398V3.48062C14.6651 3.06728 14.3718 2.56062 14.0051 2.36062L12.4051 1.47398C12.0651 1.28732 11.5051 1.28732 11.1584 1.47398Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57031 10.2988L4.21698 11.8322L6.85031 10.3055",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 14.5462V11.8262",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59594 8.80602L1.99594 9.69265C1.63594 9.89265 1.33594 10.3993 1.33594 10.8126V12.506C1.33594 12.9193 1.62927 13.426 1.99594 13.626L3.59594 14.5127C3.93594 14.706 4.49593 14.706 4.8426 14.5127L6.44261 13.626C6.80261 13.426 7.1026 12.9193 7.1026 12.506V10.8126C7.1026 10.3993 6.80927 9.89265 6.44261 9.69265L4.8426 8.80602C4.49593 8.61935 3.93594 8.61935 3.59594 8.80602Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/SyncIcon.90015d6637b7a8b9a06f51e188a3cda8.svg";
export { ForwardRef as ReactComponent };